// extracted by mini-css-extract-plugin
export default {"board":"Board_board__waieH","cellBackgroundRect":"Board_cellBackgroundRect__XYsjh","winning":"Board_winning__PMOJY","pieceSvg":"Board_pieceSvg__SBCD2"};